import React, { ReactNode, useEffect } from "react";

import SelectAccountView from "modules/auth/components/SelectAccountView";
import LoadingSpinner from "modules/core/components/LoadingSpinner";

import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";
import { useBoolean } from "modules/core/hooks/useBoolean";

import { getSubdomain, redirectToSubdomain } from "modules/core/utils/helpers";

const CheckSubdomain: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isChecked, { on: setChecked }] = useBoolean(false);

  const { data: authUser } = useAuthUserQuery();

  useEffect(() => {
    if (!authUser) return;

    const subdomain = getSubdomain();

    const account = authUser.accounts.find(acc => acc.subdomain === subdomain);

    if (!account && authUser.accounts.length === 1) {
      redirectToSubdomain(authUser.accounts[0].subdomain);
      return;
    }

    setChecked();
  }, [authUser, setChecked]);

  if (!authUser || !isChecked) return <LoadingSpinner fullScreen />;

  const isValidSubdomain = authUser.subdomains.includes(getSubdomain());

  if (!isValidSubdomain && authUser.accounts.length > 1) {
    return (
      <SelectAccountView
        accounts={authUser.accounts}
        onSelect={subdomain => {
          redirectToSubdomain(subdomain);
        }}
      />
    );
  }

  return <>{children}</>;
};

export default React.memo(CheckSubdomain);
